import { render, staticRenderFns } from "./App.vue?vue&type=template&id=63fb480c&scoped=true"
import script from "./App.js?vue&type=script&lang=js&external"
export * from "./App.js?vue&type=script&lang=js&external"
import style0 from "../styles/index.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./Tribute.scss?vue&type=style&index=1&prod&lang=scss&external"
import style2 from "./App.scss?vue&type=style&index=2&id=63fb480c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fb480c",
  null
  
)

export default component.exports